export default "__VITE_ASSET__DrUxpi83__"